<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="content video-monitor">
        <div class="leftNav">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            视频轮播
            <div class="title_btmLine"></div>
          </div>
          <el-form @submit.native.prevent>
            <el-input
              placeholder="搜索轮播组"
              class="nav-tree-filter"
              v-model="filterText"
            ></el-input>
            <div class="nav-tree-content">
              <el-tree
                style="height: 100%"
                v-loading="loading"
                :element-loading-text="loadingText"
                @node-click="nodeOneClick"
                :data="nodes"
                :load="loadNode"
                lazy
                node-key="id"
                :props="defaultProps"
                :filter-node-method="filterNode"
                class="zj-demo-player-tree-device-tree"
                ref="tree"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span style="color:#fff;">
                    <div class="video-tree-item" >
                      <div :style="{'color': data.sourceStatus && data.sourceStatus != 0 ? 'red' : '#fff' }">{{data.label}}</div>
                    </div>
                  </span>
                </span>
              </el-tree>
            </div>
          </el-form>
        </div>
        <!-- 右侧内容 -->
        <div class="rightContent">
          <div class="bottomContent">
            <!-- 左侧单个视频控制播放 v-if="cameras.length==1" :max="" -->
            <div class="changebofang">
              <div>
                轮播间隔(分钟)
                <el-input-number
                  style="margin-left: 10px"
                  v-model="num"
                  @change="handleChange"
                  :min="1"
                  label="描述文字"
                ></el-input-number>
              </div>
              <!--    -->
              <el-tooltip
                class="item"
                effect="dark"
                content="开始轮播"
                placement="top"
              >
                <div
                  style="width: 19px; height: 21px; margin-left: 15px"
                  @click="changeVideo"
                >
                  <img
                    style="width: 100%; height: 100%; cursor: pointer"
                    src="../../../../../../../public/theme/default/img/video/zanting.png"
                    alt
                  />
                </div>
              </el-tooltip>
              <div class="line"></div>
              <el-tooltip
                class="item"
                effect="dark"
                content="暂停轮播"
                placement="top"
              >
                <div style="width: 21px; height: 21px" @click="stopOneVideo">
                  <img
                    style="width: 100%; height: 100%; cursor: pointer"
                    src="../../../../../../../public/theme/default/img/video/tingzhi.png"
                    alt
                  />
                </div>
              </el-tooltip>
            </div>
            <!-- 右侧分屏数量 -->
            <div class="rightChange">
              <div class="changeLogo" @click="changeFenqi"></div>
              <div class="line" v-if="cameras.length == 1"></div>
              <div
                style="width: 31px; height: 22px"
                @click="dbOneVideo"
                v-if="cameras.length == 1"
              >
                <img
                  style="width: 100%; height: 100%"
                  src="../../../../../../../public/theme/default/img/video/fangda.png"
                  alt
                />
              </div>
            </div>
            <!-- 分屏弹窗 -->
            <ul class="fenpingBox" v-show="showFenqi">
              <li
                class="fenping_one"
                v-for="(item, index) in fenping"
                :key="index"
                @click="changeShowType(item.type, index)"
              >
                <img :src="item.src" alt />
                <div
                  style="color: #bce1ee; font-size: 14px; text-align: center"
                >
                  {{ item.type }}
                </div>
              </li>
            </ul>
          </div>
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox" v-if="showtype == '1'">
              <div class="showOneVideo">
                <div style="width: 100%; height: 100%">
                  <div style="width: 100%; height: 100%">
                    <flv-player-real-time-new
                      ref="childOneVideo"
                      class="videoBig-item"
                      :cameraId="cameras[0].cameraId"
                      :cameraName="cameras[0].cameraName"
                      :item="cameras[0].item"
                      viewMode="swiper"
                      :currentIndex="0"
                      @destoryVideo="closeVideo"
                      @play="play"
                      @stop="stop"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 分屏是一个的时候结束 -->
            <!-- 分屏是4个，第一种开始 &&showtypeIndex=='2'-->
            <div class="threes averaBox" v-if="showtype == '4'">
              <template v-for="(item, index) in cameras">
                <div
                  class="righttopvideo"
                  :key="index"
                  :class="{ martop12: index > 1 }"
                >
                  <flv-player-real-time-new
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :item="item.item"
                    viewMode="swiper"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                    @play="play"
                    @stop="stop"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是4个，第一种结束 -->
            <!-- 分屏是9个 第一种开始 &&showtypeIndex=='7'-->
            <div class="threes averaBox" v-if="showtype == '9'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :key="index">
                  <flv-player-real-time-new
                    ref="childOneVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :item="item.item"
                    viewMode="swiper"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                    @play="play"
                    @stop="stop"
                  />
                </div>
              </template>
            </div>
            <!-- 分屏是9个 第一种结束-->
          </div>
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";

import utils from "../../../../../../utils";
// const MSG = ZJPlayer.MediaCenterMsg;
// const PageSize = 100;
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
import src1 from "../../../../../../../public/theme/default/img/video/1.png";
import src3 from "../../../../../../../public/theme/default/img/video/3.png";
import src8 from "../../../../../../../public/theme/default/img/video/8.png";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
import {
  getCarouselList,
} from "@/api/src/equipment";
import { getVideoGroup, videoListTree, getVideoGroupDetail, saveVideoGroup, delVideoGroup } from "@/api/src/videoApiGb"
export default {
  controller: "UI",
  action: "swiperVideoFlv",

  destoryed() {
    this.submitIsShowbg(true);
  },

  name: "swiperVideoFlv",

  data() {
    return {
      num: 1, //分钟数
      fenping: [
        { type: "1", src: src1 },
        { type: "4", src: src3 },
        { type: "9", src: src8 },
      ],
      isStart: true,
      valueJj: 20,
      valueCircle: 20,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
        isLeaf: "leaf",
      },
      previewPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          cameraIsOnline: false,
          item:{}
        },
      ],
      selectPlayerIndex: 0,
      color: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff", "2ac1ff", "2ac1ff"],
      mc: "",
      // Triangle:"",
      showtype: "1", //摆放几个视频
      showtypeIndex: 0,
      setVideo: "",
      nodeSwiper: [],
      monitorArr: [],
      treeClickCount: 0,
      nodes:[],
    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  created() {
    this.submitIsShowbg(false);
    this.getRegionTree()
  },

  mounted() {
  },

  methods: {
    ...mapActions(["submitIsShowbg"]),

    loadNode(node, resolve) {
      // if (node.level === 0) {
      //   this.getRegionTree(resolve);
      // }else if(node.level == 1){
      //   this.getDetail(node.data.label,node.data.index, resolve);
      // }
      // if (
      //   node.level > 0 &&
      //   node.data &&
      //   node.data.children &&
      //   node.data.children.length > 0
      // ) {
      //   return resolve(node.data.children);
      // } else if (node.level > 0 && node.data) {
      //   resolve ([])
      // }
       if (node.level === 0) {
        return resolve(this.nodes)
      }
      return resolve(node.data.children)
    },
    getRegionTree() {
      let searchInfo = {
        size: 10000,
        page: 1
      };
      getVideoGroup(searchInfo).then(  res =>{
        let nodes = []
        res.data.forEach( async (item,index) => {
          let children = await this.getDetail(item.videoGroupName)
          console.log(children)
          nodes.push({
            label: item.videoGroupName,
            id: item.id,
            type: "Area",
            children,
            leaf:false,
            index
          });
        });

        this.nodes = nodes
      })
    },
    async getDetail(videoGroupName){
      let res = await getVideoGroupDetail({"page":1,"size":999,videoGroupName}),arr = [];
      if(res.code == 0 && res.data && res.data.length){
        res.data.map((item, index) =>{
          item.leaf = true
          item.children = []
          item.id = videoGroupName + index + ''
          item.label = item.detail.name
          item.sourceStatus = item.detail.sourceStatus
          arr.push(item)
        })
      }
      return arr
    },
    // 获取设备
    dbOneVideo() {
      // 全屏
      this.$refs.childOneVideo.fullScreen();
    },

    changeVideo() {
      let that = this;
      let showtype = Number(this.showtype);
      let nodeArr = this.nodeSwiper;
      if (nodeArr.length === 0) {
        this.$message.warning("请先选择轮播组");
        return;
      }
      let sliceTimes = parseInt(nodeArr.length / showtype);
      let yuTimes = nodeArr.length % showtype;
      if (yuTimes == 0) {
        sliceTimes = sliceTimes - 1;
      }
      //  console.log(sliceTimes)
      //  console.log(yuTimes)
      let changeTime = this.num * 60 * 1000;
      let i = 0;
      that.startOneVideo(i);
      this.setVideo = window.setInterval(function () {
        i++;
        if (i > sliceTimes) {
          i = 0;
        }
        that.startOneVideo(i);
      }, changeTime);
    },
    startOneVideo(i) {
      // 开始播放视频
      // this.$refs.childOneVideo.play();
      let that = this;
      let showtype = Number(this.showtype);
      let nodeArr = this.nodeSwiper;
      let swiperArr = nodeArr.slice(i * showtype, (i + 1) * showtype);
      for (let j = 0; j < swiperArr.length; j++) {
        if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          that.cameras[j].cameraId = swiperArr[j].monitorId;
          that.cameras[j].cameraName = swiperArr[j].label;
          that.cameras[j].cameraIsOnline = swiperArr[j].detail.sourceStatus;
          that.cameras[j].item = swiperArr[j].detail;
          that.selectPlayerIndex = (that.selectPlayerIndex + 1) % showtype;
          // that.getPreviewStreamInfo(
          //   that.selectPlayerIndex,
          //   swiperArr[j].id,
          //   swiperArr[j].label
          // );
        }
      }
    },
    stopOneVideo() {
      // 停止播放视频
      // this.$refs.childOneVideo.stop();
      let that = this;
      if (that.setVideo === "") {
        this.$message.warning("无轮播视频");
        return;
      }
      window.clearInterval(that.setVideo);
    },
    closeVideo(index) {
      this.$set(this.cameras, index, {
        outUrl: "",
        cameraName: "",
        item:{},
        cameraId: "",
      });
      this.isStart = false;
    },
    changeShowType(type, index) {
      // 改变视频显示个数
      this.showtype = type;
      this.showtypeIndex = index;
      let showtype = Number(this.showtype);

      let length = this.cameras.length;
      if (length <= showtype) {
        let num = showtype - length;
        for (let i = 0; i < num; i++) {
          let obj = {
            cameraId: "",
            cameraName: "",
            item:{},
            cameraIsOnline: false,
          };
          this.cameras.push(obj);
        }
      } else {
        this.cameras.splice(showtype);
      }

      this.showFenqi = false;
    },
    //根据设备id获取设备状态
    getDeviceStatus(DeviceId) {
      let result = this.monitorArr.find((item) => {
        return item.DeviceId === DeviceId;
      });
      return result.IsOnline || false;
    },
    nodeOneClick(data, node) {
      console.log(data,this.nodes)
      let showtype = Number(this.showtype);
      const that = this;
        if (node.level == 1) {
          this.nodeSwiper = this.nodes[data.index].children
          console.log(this.nodeSwiper)
        }
      if (node.level == 2) {
        if (that.cameras && that.cameras[that.selectPlayerIndex]) {
          that.cameras[that.selectPlayerIndex].cameraId = data.monitorId;
          that.cameras[that.selectPlayerIndex].cameraName = data.label;
          that.cameras[that.selectPlayerIndex].IsOnline = data.detail.sourceStatus;
          that.cameras[that.selectPlayerIndex].item = data.detail;
          that.selectPlayerIndex = (that.selectPlayerIndex + 1) % showtype;
          // that.getPreviewStreamInfo(
          //   that.selectPlayerIndex,
          //   data.id,
          //   data.label
          // );
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    changeFenqi() {
      this.showFenqi = !this.showFenqi;
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("回应");
      console.log(e);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/theme-default/_global_vars.scss";
.rightContent {
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px $zj-title-theme-color;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.topContent {
  flex: 1;
  overflow: hidden;
  width: 100%;
}
.bottomContent {
  width: 100%;
  height: 93px;
  background-color: $el-tree-bg;
  border-radius: 6px;
  border: solid 1px $zj-title-theme-color;
  margin-bottom: 20px;
  position: relative;
}

/* 选择一个视频 */
.oneVideoBox {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
/* 左侧展示视频 */
.showOneVideo {
  flex: 1;
  height: 100%;
  background-color: black;
  border: solid 1px $zj-title-theme-color;
}
.controlOneVideo {
  width: 336px;
  height: 100%;
  background-color: $el-tree-bg;
  border: solid 1px $zj-title-theme-color;
  position: relative;
  margin-left: 30px;
}
.videoOne {
  width: 100%;
  height: 100%;
}
.video-wrapper {
  width: 100%;
  height: 100%;
}

/* 滑块样式 */
.block {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.zj_slider {
  width: 220px;
}
/* 选择分屏的样式 */
.changeLogo {
  width: 31px;
  height: 22px;
  background: url("../../../../../../../public/theme/default/img/video/fenping.png")
    no-repeat;
}
.fenpingBox {
  width: 200px;
  background-color: $el-tree-bg;
  border: solid 1px $zj-title-theme-color;
  position: absolute;
  right: 10px;
  bottom: -86px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px;
  z-index: 10000;
}
.fenping_one {
  list-style: none;
  margin-right: 10px;
  cursor: pointer;
}
.fenping_one img {
  width: 31px;
  height: 24px;
  margin-bottom: 8px;
}
.martop2 {
  margin-top: 15px;
}

/* 三个视频 */
.threes {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
.leftBigVideo {
  flex: 1;
  height: 100%;
  border: solid 1px $zj-title-theme-color;
  margin-right: 20px;
}
.leftVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.rightVideo {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.righttopvideo {
  height: 48%;
  width: 49%;
  border: solid 1px $zj-title-theme-color;
}
.rightbottomvideo {
  height: 49%;
  width: 100%;
  border: solid 1px $zj-title-theme-color;
}
.videoBig-item {
  width: 100%;
  height: 100%;
}
.rightvideo3 {
  height: 32%;
  width: 100%;
  border: solid 1px $zj-title-theme-color;
}
/* 6个平分的样式 */
.videoSix {
  width: 49%;
  height: 32%;
  border: solid 1px $zj-title-theme-color;
}
.averaBox {
  flex-wrap: wrap;
}
.videoSixtop {
  width: 49%;
  height: 48%;
  border: solid 1px $zj-title-theme-color;
}
.videoSixbottom {
  width: 23.5%;
  height: 49%;
  border: solid 1px $zj-title-theme-color;
  margin-top: 15px;
}
.rightvideo7 {
  width: 48%;
  height: 32%;
  border: solid 1px $zj-title-theme-color;
}
.rightvideo9 {
  width: 32%;
  height: 32%;
  border: solid 1px $zj-title-theme-color;
}
.videoNinetop {
  width: 100%;
  height: 48%;
  border: solid 1px $zj-title-theme-color;
}
.videoNinebottom {
  width: 49%;
  height: 49%;
  border: solid 1px $zj-title-theme-color;
  margin-top: 15px;
}
.rightvideo12 {
  width: 23%;
  height: 32%;
  border: solid 1px $zj-title-theme-color;
}
.martop12 {
  margin-top: 10px;
}
.rightvideo15 {
  width: 19%;
  height: 31%;
  border: solid 1px $zj-title-theme-color;
}
.rightvideomini {
  width: 15.5%;
  height: 32%;
  border: solid 1px $zj-title-theme-color;
}
.rightvideo16 {
  width: 24%;
  height: 24%;
  border: solid 1px $zj-title-theme-color;
}
.rightvideo24 {
  width: 15.5%;
  height: 24%;
  border: solid 1px $zj-title-theme-color;
}

.changebofang {
  display: flex;
  align-items: center;
  position: absolute;
  left: 39px;
  top: 34px;
}
.line {
  width: 2px;
  height: 26px;
  background: linear-gradient(90deg, #00bcfe 0%, #4ed1ff 100%);
  margin-left: 29px;
  margin-right: 29px;
  opacity: 0.4;
}
.rightChange {
  position: absolute;
  right: 30px;
  top: 34px;
  display: flex;
  align-items: center;
}
</style>